import http from "../api";

class CatalogoVirtualDataService {

    getItensCatalogo() {
        return http({
            'url':'/catalogo_virtual/itens',
            'method':'GET',
        });
    }

    getCatalogoVirtualItemById(id) {
        return http({
            'url':'/catalogo_virtual/item/'+id,
            'method':'GET'
        });
    }

    handleDuplicateItem(id) {
        return http({
            'url':'/catalogo_virtual/duplicate_item/'+id,
            'method':'POST'
        });
    }

    handleDeleteItemBgImage(id, prop) {
        return http({
            'url':'/catalogo_virtual/remove_bg_item/'+id+'/'+prop,
            'method':'POST'
        });
    }

    handleSaveOrders(data) {
        return http({
            'url':'/catalogo_virtual/updateOrder',
            'method':'POST',
            'data':data
        });
    }

    createCatalogoVirtualItemData(data) {
        return http({
            'url':'/catalogo_virtual/item',
            'method':'POST',
            headers: {
                'Content-Type':'multipart/form-data; boundary=----WebKitFormBoundaryYfmIyu4VricsS1by',
                'x-tenant-id': localStorage.getItem('tenantId')
            },
            withCredentials:true,
            'data': data
        });
    }

    updateCatalogoVirtualItemData(id, data) {
        return http({
            'url':'/catalogo_virtual/item/'+id,
            'method':'PUT',
            headers: {
                'Content-Type':'multipart/form-data; boundary=----WebKitFormBoundaryYfmIyu4VricsS1by',
                'x-tenant-id': localStorage.getItem('tenantId')
            },
            withCredentials:true,
            'data': data
        });
    }

    uploadCatalogoVirtualItemSessionFile(data) {
        return http({
            'url':'/catalogo_virtual/itemFile',
            'method':'POST',
            headers: {
                'Content-Type':'multipart/form-data; boundary=----WebKitFormBoundaryYfmIyu4VricsS1by',
                'x-tenant-id': localStorage.getItem('tenantId')
            },
            withCredentials:true,
            'data': data
        });
    }

    updateCatalogoVirtualData(data) {
        return http({
            'url':'/catalogo_virtual',
            'method':'PUT',
            headers: {
                'Content-Type':'multipart/form-data; boundary=----WebKitFormBoundaryYfmIyu4VricsS1by',
                'x-tenant-id': localStorage.getItem('tenantId')
            },
            withCredentials:true,
            'data': data
        });
    }

    softDeleteCatalogoVirtualItem(id) {
        return http({
            'url':'/catalogo_virtual/item/softDelete/'+id,
            'method':'PUT'
        });
    }

    removeCatalogoVirtualItem(id) {
        return http({
            'url':'/catalogo_virtual/item/'+id,
            'method':'DELETE'
        });
    }
}

export default new CatalogoVirtualDataService();